module.exports = __webpack_public_path__ + "static/media/loading.234166fa.svg";